import type { AppRightsPermission } from "src/components/types/types";

export const digitToWordConverter = (num: number): string => {
    const units = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 
                   'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 
                   'eighteen', 'nineteen'];
    const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  
    if (num === 0) return 'zero';
    
    if (num < 20) {
      return units[num];
    }
    
    if (num < 100) {
      const tenDigit = Math.floor(num / 10);
      const unitDigit = num % 10;
      return unitDigit === 0 ? tens[tenDigit] : `${tens[tenDigit]}-${units[unitDigit]}`;
    }
    
    if (num < 1000) {
      const hundredDigit = Math.floor(num / 100);
      const remainder = num % 100;
      return remainder === 0 
        ? `${units[hundredDigit]} hundred` 
        : `${units[hundredDigit]} hundred and ${digitToWordConverter(remainder)}`;
    }
    
    return num.toString(); // Fallback for numbers >= 1000
  };

export const checkEventPermission = (rightCode: string): boolean => {
    const storedappRights = JSON.parse(localStorage.getItem('appRights') ?? '[]') as AppRightsPermission[];
    return storedappRights.some((right: AppRightsPermission) => right.rightCode === rightCode);
};
